mutation acceptMarketingPlanOutline($input: AcceptMarketingPlanOutlineInput!) {
  plan: acceptMarketingPlanOutline(input: $input) {
    id
    status
  }
}
